import { z } from 'zod';

const domainSchema = z.object({
  subdomain: z.string(),
  customDomain: z.string().nullable(),
  customDomainAllowed: z.boolean(),
  target: z.string(),
});

const checkSchema = z.object({
  status: z.enum(['connected', 'waiting', 'mismatch']),
  detail: z.string(),
});

export type TenantDomain = z.infer<typeof domainSchema>;
export type DomainCheck = z.infer<typeof checkSchema>;

export function parseTenantDomain(payload: unknown): TenantDomain {
  const parsed = domainSchema.safeParse(payload);
  if (!parsed.success) throw new Error('The domain settings could not be read.');
  return parsed.data;
}

export function parseDomainCheck(payload: unknown): DomainCheck {
  const parsed = checkSchema.safeParse(payload);
  if (!parsed.success) throw new Error('The DNS check could not be read.');
  return parsed.data;
}
